import {
  Button,
  Col,
  Descriptions,
  List,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import {HeaderPrintForm, Notification} from "components/common";
import Sign from "components/common/PrintForm/Sign/Sign";
import React, {useEffect, useRef, useState} from "react";
import ReactToPrint from "react-to-print";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import "./config";
import {formatDateToString, formatToCurrencyType} from "helper/common";
import {FORMAT_TIME} from "types/enums";
import "./style.scss";
import {InfoItem} from "components/common/PrintForm";
import moment from "moment";
import consultantAndFragmentService from "api/consulantAndFragtment";
import {setDataConsultantAndFragment} from "redux/reducer/consultantAndFragment";
import {columnsTableMenu} from "./config";
import TinhTongGia from "pages/CustomerService/ConsultantAndTreament/Detail/ModalAddService/tinhTien";
import SearchPatientService from "api/searchPatient";
const ConsulantAndFragtmentPrint = props => {
  const {closeModal} = props;
  const detailPhieu = useAppSelector(e => e.consultantAndFragment.data);

  const lichSuTuVan = useAppSelector(
    e =>
      (e.consultantAndFragment?.data?.lichSuTuVanDtos &&
        e.consultantAndFragment?.data?.lichSuTuVanDtos[
          e.consultantAndFragment?.data?.lichSuTuVanDtos?.length - 1
        ]) ||
      null
  );
  const dispatch = useAppDispatch();

  const id = useAppSelector(
    e => e.consultantAndFragment?.idConsultantAndFragment
  );
  //lấy thông tin phiếu in
  const getDetailsConsultantAndFragment = async () => {
    try {
      const res = await SearchPatientService.getDetailConsultantAndFragmentById(
        id
      );

      dispatch(setDataConsultantAndFragment(res));
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
    }
  };

  useEffect(() => {
    if (id !== null) {
      getDetailsConsultantAndFragment();
    }
  }, [id]);
  const printRef = useRef<any>();

  const fields1 = [
    {
      label: "Họ và tên",
      value: detailPhieu?.hoTen?.toString()?.toUpperCase(),
    },
    {
      label: "Ngày sinh - Giới tính",
      value: `${formatDateToString(
        detailPhieu?.ngaySinh,
        FORMAT_TIME.dayFull
      )} - ${detailPhieu?.gioiTinh == 0 ? "Nam" : "Nữ"}`,
    },
    {label: "Điện thoại", value: detailPhieu?.dienThoai},
    {label: "Địa chỉ", value: detailPhieu?.diaChiTongHop},
  ];
  const fields2 = [
    {
      label: "Khám bệnh lúc",
      value: formatDateToString(detailPhieu?.thoiGianKham, FORMAT_TIME.dayFull),
    },
    {label: "Mã bệnh nhân", value: detailPhieu?.maBenhNhan},
    {label: "Mã phiếu khám", value: detailPhieu?.idPhieuKham},
    {label: "Lý do khám", value: detailPhieu?.lyDoKham},
  ];
  const onPrint = () => {
    window.print();
  };
  useEffect(() => {
    columnsTableMenu.find(e => e.dataIndex === "tongNbTra").render = v => {
      const tongGiaBHYT = TinhTongGia(detailPhieu?.dmGoiDichVuDtos, "giaBH");
      const tongGiaBv = TinhTongGia(detailPhieu?.dmGoiDichVuDtos, "giaBv");
      const mucBVGiam = TinhTongGia(detailPhieu?.dmGoiDichVuDtos, "mucBVGiam");
      const tongNbTra = formatToCurrencyType(
        Math.round(
          (tongGiaBHYT * (1 - 0.8) + (tongGiaBv - tongGiaBHYT) - mucBVGiam) /
            1000
        ) * 1000
      );
      return tongNbTra;
    };
  }, [detailPhieu]);
  return (
    <div className="phieu-tu-van">
      <div className="layout" ref={printRef}>
        <HeaderPrintForm></HeaderPrintForm>
        <div>
          <div>
            <InfoItem
              fields1={fields1}
              fields2={fields2}
              idBenhNhan={detailPhieu?.maBenhNhan}
              title={"PHIẾU KẾT QUẢ TƯ VẤN"}
              isChiefComplant={false}
            />
          </div>
          <Space direction="vertical" style={{width: "100%"}}>
            <div>
              <Row className="title-name">Chẩn đoán (ICD)</Row>
              <ul style={{marginLeft: "25px"}}>
                {detailPhieu?.ketLuanDto &&
                  detailPhieu?.ketLuanDto?.chiTietKetLuans.map(item => (
                    <li key={item.maIcd}>
                      {item?.maIcd} - {item.tenIcd}
                    </li>
                  ))}
              </ul>
            </div>
            <div>
              <Row className="title-name">Bệnh phụ</Row>
              <ul style={{marginLeft: "30px"}}>
                {detailPhieu?.ketLuanDto &&
                  detailPhieu?.ketLuanDto?.chiTietBenhPhuDtos.map(item => (
                    <li key={item.maIcd}>
                      {item?.maIcd} - {item.tenIcd}
                    </li>
                  ))}
              </ul>
            </div>
            {/* {detailPhieu?.ketLuanDto?.taiKham && ( */}
            {/* <> */}
            <Row className="title-name">Ghi chú </Row>
            <div style={{marginLeft: "15px"}}>
              {detailPhieu?.ketLuanDto?.taiKham}
            </div>
            {/* </> */}
            {/* )} */}
            <div>
              <Row className="title-name">Trạng thái tư vấn</Row>
              <ul style={{marginLeft: "30px"}}>
                <li>
                  {lichSuTuVan?.tenTrangThai}
                  {lichSuTuVan?.thoiGianTuVan
                    ? " - " +
                      moment(lichSuTuVan?.thoiGianTuVan).format(
                        FORMAT_TIME.dateTime
                      )
                    : ""}{" "}
                  {lichSuTuVan?.ghiChu ? lichSuTuVan?.ghiChu + " - " : ""}
                </li>
              </ul>
            </div>
            <div className="table-print-tu-van">
              <Row className="title-name">Gói phẫu thuật lựa chọn</Row>
              {/* <ul style={{marginLeft: "30px"}}>
                {detailPhieu?.dmGoiDichVuDtos
                  ? detailPhieu?.dmGoiDichVuDtos.map(item => (
                      <li>{item.tenGoiDichVu}</li>
                    ))
                  : ""}
              </ul> */}
              <Table
                columns={columnsTableMenu}
                dataSource={detailPhieu?.dmGoiDichVuDtos}
                pagination={false}
              />
            </div>
          </Space>
          <Sign
            nguoiThucHien={detailPhieu?.nvTuVan ?? ""}
            time={detailPhieu?.thoiGianKham}
          ></Sign>
        </div>
      </div>
      <Row justify={"end"} className="footer">
        <Space direction="horizontal">
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="phieu-tu-van"
            onAfterPrint={closeModal}
          />
        </Space>
      </Row>
    </div>
  );
};
export default ConsulantAndFragtmentPrint;
